import { useRideOrderMarketplaceRoutes } from './rom/useRideOrderMarketplaceRoutes';
import { TabNavigation } from 'src/common/TabNavigation';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';

const tabs = [
  { name: 'Trips', href: '/trips' },
  {
    name: 'Subscriptions',
    href: '/trips/subscriptions',
    matcher: '/trips/subscriptions/*',
  },
];

const routeTemplatesTab = {
  name: 'Route Templates',
  href: '/trips/route-templates',
};

const rideOrderingPortalTabs = [{ name: 'Trips', href: '/trips' }];

export function TripsNav() {
  const shouldUseRideOrderingPortalRoutes =
    useShouldShowRideOrderingPortalFeatures();

  const { tabs: nonRideOrderingTabs, isLoading } =
    useRideOrderMarketplaceRoutes(tabs);

  if (shouldUseRideOrderingPortalRoutes) {
    return <TabNavigation tabs={rideOrderingPortalTabs} />;
  }

  return (
    <TabNavigation
      tabs={[...nonRideOrderingTabs, routeTemplatesTab]}
      isLoading={isLoading}
    />
  );
}
